module.exports = __webpack_public_path__ + "img/point_festival_wholesale_kv.b4145ab2.jpg";